module.exports = __webpack_public_path__ + "img/porsche.d632009a.png";